import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosDefaultSetting from "../AxiosDefault";

//get parameters list
export const getAllParameters = createAsyncThunk(
  "templates/getParameters",
  async (data, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      page_size,
      page,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/parameters?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get parameter values
export const getParameterValues = createAsyncThunk(
  "templates/Values",
  async (data, { rejectWithValue }) => {
    let queryParams = "";

    if (data) {
      for (const key in data) {
        queryParams += queryParams.length
          ? `&${key}=${data[key]}`
          : `${key}=${data[key]}`;
      }
    }

    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/parameters/values?${queryParams}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get templates list
export const getAllDocumentTemplates = createAsyncThunk(
  "templates/getTemplates",
  async (data, { rejectWithValue }) => {
    const { order_type, order_by, page_size, page, search_text, ...rest } =
      data;
    const queryString = new URLSearchParams({
      page_size,
      page,
      search_text,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/templates?${queryString}`, //endpoint
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get single template by id
export const getDocumentTemplate = createAsyncThunk(
  "templates/getTemplate",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/templates?${id}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//add template
export const addTemplate = createAsyncThunk(
  "templates/addTemplate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/templates", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//update template data
export const updateTemplate = createAsyncThunk(
  "templates/updateTemplate",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/templates/${id}`, //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//delete template
export const deleteTemplate = createAsyncThunk(
  "templates/deleteTemplate",
  async ({ id, templates, totalTemplates }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/templates/${id}`, //endpoint
      });
      return { ...response.data, id, templates, totalTemplates };
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
